import { render, staticRenderFns } from "./MoveDialog.vue?vue&type=template&id=fa6a4440&scoped=true&"
import script from "./MoveDialog.vue?vue&type=script&lang=js&"
export * from "./MoveDialog.vue?vue&type=script&lang=js&"
import style0 from "./MoveDialog.vue?vue&type=style&index=0&id=fa6a4440&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6a4440",
  null
  
)

export default component.exports